export class RegexHelper {
	static ipAddress() {
		return /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/;
	}

	static registersRange(): string {
		let range: string = '[0-9]|[0-9][0-9]|[0-9][0-9][0-9]|[0-9][0-9][0-9][0-9]';
		let firstRangeGroup: string = `((${range}):(${range}))`;
		let nextRangeGroup: string = `(;(${range}):(${range}))`;
		return `${firstRangeGroup}${nextRangeGroup}?${nextRangeGroup}?${nextRangeGroup}?${nextRangeGroup}?`;
	}

	static phoneNumber() {
		return /^\(\d{3}\)\s\d{3}-\d{4}$/;
	}
}
